import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { textFormatBrushShortcutItem } from './text-format-brush-item';

const TextLayerShortcutMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);

        framework.service.registration.getInstance<ShortcutMenu>('ShortcutMenu').addItems([
            {
                key: 'text-format-brush-90',
                sort: 90,
                render: textFormatBrushShortcutItem,
            },
        ]);
    }, []);

    return null;
});

export const textLayerShortcutMenuPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'text-layer-shortcut-menu',
    render() {
        return <TextLayerShortcutMenuView />;
    },
};
